<template>
  <div class="template">
    <section class="py-24 bg-slate-50 dark:bg-slate-900/50">
      <div
        class="container mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center"
      >
        <div
          class="relative group aspect-video bg-black rounded-3xl overflow-hidden shadow-2xl"
        >
          <!-- <img
            alt="Factory"
            class="w-full h-full object-cover opacity-60 group-hover:scale-105 transition-transform duration-700"
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuAe_jSJYqfetV2ZhGf8O8bCsTMWDRm3z6MDfd4_Ld_jNG0jDMJVwrs6QhkX_OiPvuKZgoyk7sqDriWVMK1ct1PIeN7d6ncZz3thprcGlEivaT1azQBtG39dOyU9n7U-ksgjiw5F67bFXeSxKsGN23ynyO-rRY2eYoyLwFOvUYQMlWC9q5nJz0roRCUZIJhit-hWziYh2EXliouBl30feMAdnk6nEEkCe9A5FFnrjnw4AcEP7cTVrHrlHIKDUyLVjVwsZLHICK3VxoY"
          />
          <div class="absolute inset-0 flex items-center justify-center">
            <button
              class="w-20 h-20 bg-primary/90 text-white rounded-full flex items-center justify-center hover:scale-110 transition-transform shadow-xl"
            >
              <i class="material-icons text-4xl">play_arrow</i>
            </button>
          </div> -->
          <iframe
            class="h-full w-full"
            src="https://www.youtube.com/embed/ieWSok2k5ng"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </div>
        <div class="space-y-6">
          <h2 class="text-3xl font-bold text-slate-900 dark:text-white">
            COMPANY INTRODUCTION
          </h2>
          <div class="w-16 h-1 bg-primary"></div>
          <div class="prose prose-slate dark:prose-invert">
            <p class="text-slate-600 dark:text-slate-400">
              Dongguan Huadai Silicone Co., Ltd. was founded in 2017 and located
              in Dongguan, Guangdong, China, which is a National High tech
              Enterprise specializing in R&D, manufacturing and sales of
              silicone rubber. The company covers an area of 30,000 square
              meters, with an annual production capacity of 35000 tons, of which
              HCR is 30,000 tons and LSR is 5,000 tons.
            </p>
            <p class="text-slate-600 dark:text-slate-400">
              With over 18 years' experience, we have developed a keen insight
              into customer needs.
            </p>
          </div>
          <div class="grid grid-cols-2 gap-6 pt-4">
            <div class="flex items-start gap-3">
              <!-- <i class="material-icons text-primary">verified</i>
              <div>
                <h4 class="font-bold text-slate-900 dark:text-white">
                  Quality First
                </h4>
                <p class="text-xs text-slate-500">Rigorous QC standards</p>
              </div> -->
            </div>
            <div class="flex items-start gap-3">
              <button
                class="inline-flex items-center gap-2 border border-primary text-primary px-8 py-3 rounded-full hover:bg-primary hover:text-white transition-all font-semibold"
                @click="naviAboutUs"
              >
                See more informations
                <i class="material-icons text-sm">grid_view</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Template',
  components: {},
  data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
    naviAboutUs() {
      this.$router.push({
        path: '/aboutus'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/page/index/CompanyIntroduction.vue